import { ChangeEvent, useEffect, useState } from "react";
import { GetLastYears } from "utils/dateUtils";
import MonthSelect from "./MonthSelect";

interface IProps {
  selectDate: (data: { dateFrom: Date; dateTo: Date }) => void;
  lastYearNumbers?: number;
  showYear?: boolean;
  showMonth?: boolean;
  selectedYear?: number;
  classes?: string;
}

const DateSelector = ({
  selectDate,
  lastYearNumbers = 2,
  showYear = true,
  showMonth = true,
  selectedYear,
  classes = ""
}: IProps) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(showMonth ? new Date().getMonth() : 0);

  const years = GetLastYears(lastYearNumbers);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    let { name, value } = event.target;
    name === "year" ? setYear(Number(value)) : setMonth(Number(value) - 1);
  };

  useEffect(() => {
    if (selectedYear) {
      setYear(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    selectDate({
      dateFrom: new Date(year, month, 1),
      dateTo: new Date(year, showMonth ? month + 1 : month + 12, 0),
    });
  }, [selectDate, showMonth, year, month]);

  return (
    <>
      {showYear && (
        <select
          value={year}
          name="year"
          className={classes}
          onChange={handleChange}
        >
          {years.map((year, index) => (
            <option value={year} key={index}>
              {year}
            </option>
          ))}
        </select>
      )}
      {showMonth && (
        <MonthSelect defaultValue={month + 1} onChange={handleChange} />
      )}
    </>
  );
};

export default DateSelector;
